import React, { useContext, useEffect, useState } from "react";
import { Outlet, useNavigate } from "react-router-dom";
import { ContextData } from "../../../context/Context";
import GetPersonData from "../../../context/GetPersonData";
import { User } from "lucide-react";
import GetAdminCredentials from "../../../context/GetAdminCredentials";

function Settings() {

  const [searchText, setSearchText] = useState("");

  const handleSearchChange = (e) => {
    setSearchText(e.target.value);
  };

  const Navigate = useNavigate()

  const [Changeroutes,setChangeroutes] = React.useState(null)
  const {Checker,UserTokens,accesstoken} = useContext(ContextData)
  const [UserType,setUserType] = React.useState("")

   const  user_roles = [
          "Administrator",
          "Manage",
          "Selector",
          "Validator",
          "Verifier",
          "Bank reviewer",
          "account-helper",
          "Manage Loan",
          "Manage Scholarship",
          "Manage Loan General"
           ]


      React.useEffect(()=>{
  
          (async ()=>{
  
                  GetAdminCredentials(UserTokens,accesstoken).then(res =>{
                       setUserType(res)
                  })
                 
          })()
  
  
  
      },[]) 
  

    useEffect(()=>{
          
          

        if(UserType[0]?.acct_typ === user_roles[0]){

           setChangeroutes( [
           
            {
              path: "update-password",
              name: "Update Password",
            },
            {
              path: "limitscholarship",
              name: "Limit Scholarship",
            },

            {
              path: "add-document",
              name: "Add Document",
            },
            {
              path: "upload-document",
              name: "Loan Documents Download",
            },
            {
              path: "add-university",
              name: "Add University",
            },
            {
              path: "add-bank",
              name: "Add Bank",
            }
            
          ])
 





        }else if(UserType[0]?.acct_typ === user_roles[7] ){

           setChangeroutes( [
           
            {
              path: "update-password",
              name: "Update Password",
            }
            
          ])
 





        }else if(UserType[0]?.acct_typ === user_roles[9] ){

           setChangeroutes( [
           
            {
              path: "update-password",
              name: "Update Password",
            },

            {
              path: "add-document",
              name: "Add Document",
            },
            {
              path: "upload-document",
              name: "Loan Documents Download",
            }
            
          ])
 





        } else if(user_roles.filter(role => role !== user_roles[0] && role !== user_roles[7]).includes(UserType[0]?.acct_typ) ){


           setChangeroutes( [
           
            {
              path: "update-password",
              name: "Update Password",
            }
            
          ])
           
             

        }





    },[UserType])
 

  return (
    <div className="award-flex-con w-full flex h-full">
      <div
        style={{ height: "" }}
        className="award w-1/4 bg-slate-100 h-screen overflow-auto border-r-2 border-b-slate-600 border-solid"
      >
        <ul className="ver-aside-ul  ">
       
          {Changeroutes !== null && Changeroutes.map((item, index) => (

                
            <li key={index} className="flex justify-between items-center"
            onClick={() => {
                Navigate(item.path);
              }} >
              <span className="p-3"> {item.name}</span>{" "}
            </li>


          ))}

        </ul>
      </div>

      <div style={{ height: "95vh" }} className="batch w-3/4  overflow-auto">
        <Outlet />
      </div> 
    </div>
  );
}

export default Settings;
